<template>
  <div id="app" class="small-container">
    <landing-page />
  </div>
</template>

<script>
  import LandingPage from '@/components/LandingPage.vue'

export default {
  name: 'app',
  components: {
    LandingPage,
  },
}
</script>

<style>
  button {
    background: #009435;
    border: 1px solid #009435;
  }

  .small-container {
    max-width: 680px;
  }
</style>

